import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="section px-6 lg:px-10 min-h-[70vh] flex items-center" data-testid="not-found-page">
      <div>
        <div className="font-display text-[20vw] lg:text-[16vw] leading-none tracking-tighter text-[#FF5722]">404</div>
        <div className="eyebrow mt-4">Signal Lost</div>
        <h1 className="font-display text-4xl md:text-6xl mt-2 tracking-tighter">This page doesn't exist.</h1>
        <p className="text-zinc-400 mt-6 max-w-lg">
          The URL may have moved or been retired. Head back to the homepage or explore our services below.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/" className="btn-primary" data-testid="404-home">Home</Link>
          <Link to="/services" className="btn-ghost">Services</Link>
          <Link to="/quote" className="btn-ghost">Request a Quote</Link>
        </div>
      </div>
    </div>
  );
}
